import component from "./ProfileInfo.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileInfo"

export default wrapVueComponent(componentName, component)
